// Function to generate random values for sold items and hours
function generateRandomValues() {
    // Randomly generate sold items (between 1 and 1000)
    const soldItems = Math.floor(Math.random() * 1000) + 1;

    // Randomly generate the number of hours (between 1 and 24)
    const hours = Math.floor(Math.random() * 24) + 1;

    // Update the counter on the page
    document.getElementById('odItems-{{ section.id }}').textContent = soldItems;
    document.getElementById('odTime-{{ section.id }}').textContent = hours;
}

// Update the counter every 5 seconds (5000ms) with random values
setInterval(generateRandomValues, 5000);
